var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/lineChinnel" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("跟进类型设置")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("跟进记录设定")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            { attrs: { inline: true, id: "search" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "内容:" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "mini",
                      placeholder: "请输入内容",
                      clearable: "",
                    },
                    model: {
                      value: _vm.search.name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.search,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "search.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态类型:" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择订单类型",
                        size: "mini",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "status", $$v)
                        },
                        expression: "search.status",
                      },
                    },
                    _vm._l(_vm.stateType, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: {
                          label: item.dictName,
                          value: item.dictId,
                          clearable: "",
                          filterable: "",
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("search")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c("p", { staticClass: "header" }, [_vm._v("跟进类型列表")]),
            _vm.parArray.indexOf("addJcRecord") != -1
              ? _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "13px",
                    },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("add")
                      },
                    },
                  },
                  [_vm._v("新 增")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "el-table",
              {
                attrs: {
                  border: "",
                  "header-cell-style": { background: "#f8f8f8" },
                  data: _vm.tableData.list,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", label: "序号", width: "100" },
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "150px",
                    scope: "scope",
                    label: "内容",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.edit
                            ? _c("el-input", {
                                model: {
                                  value: scope.row.name,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "name", $$v)
                                  },
                                  expression: "scope.row.name",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "150px",
                    scope: "scope",
                    label: "状态类型",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.status == 0
                                  ? "无"
                                  : "" || scope.row.status == 1
                                  ? "接通"
                                  : "" || scope.row.status == 2
                                  ? "未接通"
                                  : "" || scope.row.status == 3
                                  ? "已添加"
                                  : "" || scope.row.status == 4
                                  ? "未添加"
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { prop: "createdTime", label: "更新时间" },
                }),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "optain" },
                            [
                              _vm.parArray.indexOf("editRecord") != -1 &&
                              !scope.row.edit
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDialog(
                                            "edit",
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" 编辑 ")]
                                  )
                                : _vm._e(),
                              _vm.parArray.indexOf("delectRecord") != -1
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#f33f3f" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.delect(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_c("span", [_vm._v("删除")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("div", { staticClass: "page" }, [
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pageNo,
                      "page-size": _vm.pageSize,
                      layout: "total,sizes,prev, pager, next",
                      "prev-text": "上一页",
                      "next-text": "下一页",
                      total: _vm.tableData.totalNum,
                    },
                    on: {
                      "size-change": _vm.handleSizeEmplay,
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function ($event) {
                        _vm.pageNo = $event
                      },
                      "update:current-page": function ($event) {
                        _vm.pageNo = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: "30%",
            "before-close": _vm.handleClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.dialogForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "状态类型:", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择状态类型", clearable: "" },
                      model: {
                        value: _vm.dialogForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.dialogForm, "status", $$v)
                        },
                        expression: "dialogForm.status",
                      },
                    },
                    _vm._l(_vm.stateType, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: {
                          label: item.dictName,
                          value: item.dictId,
                          clearable: "",
                          filterable: "",
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "内容:", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: "20",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.dialogForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dialogForm, "name", $$v)
                      },
                      expression: "dialogForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "right" } },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialog.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("dialogForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }